import styles from './Loading.module.css';

function Loading({ ...props }) {
  return (
    <div className={`${styles.container}`}>
      <div className={styles.position}>
        <div className={styles.brandC}></div>
        <div className={styles.loading}>
          <svg viewBox="0 0 125 125">
            <polygon points="80 13 110 40 110 80 80 110 40 110 13 80 13 40 40 13" />
          </svg>
        </div>

        {/*
      <div className={styles.cube}>
        <div className={styles.top}>Top</div>
        <div className={styles.right}>Right</div>
        <div className={styles.bottom}>Bottom</div>
        <div className={styles.left}>Left</div>
        <div className={styles.front}>Front</div>
        <div className={styles.back}>Back</div>
      </div>
      
      <h1 className={styles.loadingHeading}>
        <span>Loading...</span>
      </h1>
    */}
      </div>
    </div>
  );
}

export default Loading;
